import { render } from "./Pagination.vue?vue&type=template&id=cf1334e8&scoped=true"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import "./Pagination.vue?vue&type=style&index=0&id=cf1334e8&scoped=true&lang=css"

import exportComponent from "/tmp/pelican-managers-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf1334e8"]])

export default __exports__